import FormattedMessage from 'I18n/components/FormattedMessage';
import { EXISTING_PANEL, ADD_NEW_PANEL } from 'FormsUI/constants/PropertyNavigationTabs';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `editor.form.properties.${suffix}`;
const LeftPanelNavigationTabs = ({
  selectedTab = EXISTING_PANEL,
  onTabChange = () => {}
}) => {
  const handleOnTabChange = ({
    target: {
      value
    }
  }) => {
    onTabChange(value);
  };
  return /*#__PURE__*/_jsxs(Tabs, {
    fill: true,
    use: "enclosed",
    selected: selectedTab,
    onSelectedChange: handleOnTabChange,
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: EXISTING_PANEL,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('existingProperties')
      }),
      "data-tour-step": "existing-properties"
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: ADD_NEW_PANEL,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('createNew.cta')
      })
    })]
  });
};
export default LeftPanelNavigationTabs;